module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step1-form step2_bl",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [(this.$route.query.yanse == 1) ? _c('div', {
    staticClass: "step-form__step-num2"
  }, [_vm._v("5/5")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("5/5")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v(_vm._s(this.$route.query.productName) + "-申请信息确认")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "step5Form",
    staticClass: "step-form__form",
    attrs: {
      "label-width": '50%',
      "model": _vm.step5Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "融资申请编号"
    }
  }, [_vm._v("\n               " + _vm._s(this.applyCode) + "\n             ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可申请融资金额"
    }
  }, [_vm._v("\n              ￥" + _vm._s(_vm._f("addThousandSign")(this.canApplyAmount, 2)) + " "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "smaller"
    }
  }, [_vm._v("  （本次融资产品最高融资比例为" + _vm._s(this.canApplyRate) + "%）")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "本次申请融资金额",
      "prop": "applyAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text ",
      "placeholder": "请输入本次申请融资金额"
    },
    model: {
      value: (_vm.step5Form.applyAmount),
      callback: function($$v) {
        _vm.$set(_vm.step5Form, "applyAmount", $$v)
      },
      expression: "step5Form.applyAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应收账款到期日",
      "prop": "accountsReceivableEndTime"
    }
  }, [_c('el-date-picker', {
    ref: "accountsReceivableEndTime",
    attrs: {
      "type": "date",
      "disabled": !_vm.showAccountsReceivableEndTime,
      "placeholder": "应收账款到期日",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.dateChange($event, 'accountsReceivableEndTime')
      }
    },
    model: {
      value: (_vm.step5Form.accountsReceivableEndTime),
      callback: function($$v) {
        _vm.$set(_vm.step5Form, "accountsReceivableEndTime", $$v)
      },
      expression: "step5Form.accountsReceivableEndTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticClass: "step-form_main__title"
  }, [_vm._v("应收账款")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.voucherInfoList,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "buyerName",
      "label": "买方",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应收账款金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(_vm._f("addThousandSign")(scope.row.receivableAmount, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authStateName",
      "label": "审核状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应收账款净额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(_vm._f("addThousandSign")(scope.row.netAmount, 2)))]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    class: this.$route.query.yanse == 1 ? 'step-from_main__money2' : 'step-from_main__money'
  }, [_c('span', [_vm._v("应收账款总金额："), _c('i', [_vm._v("￥" + _vm._s(_vm._f("addThousandSign")(this.receivableAmountSum, 2)))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("应收账款总净额："), _c('i', [_vm._v("￥" + _vm._s(_vm._f("addThousandSign")(this.netAmountSum, 2)))])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form_main__name"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticClass: "step-form_main__title"
  }, [_vm._v("经办人信息")]), _vm._v(" "), _c('div', {
    class: this.$route.query.yanse == 1 ? 'deo-company-main-body2' : 'deo-company-main-body'
  }, [_c('ul', {
    staticClass: "deo-company-list-box"
  }, [_c('li', [_c('div', {
    staticClass: "deo-company-list-left"
  }, [_vm._v("经办人")]), _vm._v(" "), _c('div', {
    staticClass: "deo-company-list-right"
  }, [_vm._v(_vm._s(this.agent))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "deo-company-list-left"
  }, [_vm._v("经办人身份证")]), _vm._v(" "), _c('div', {
    staticClass: "deo-company-list-right"
  }, [_vm._v(_vm._s(this.agentIdNo))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "deo-company-list-left"
  }, [_vm._v("经办人电话")]), _vm._v(" "), _c('div', {
    staticClass: "deo-company-list-right"
  }, [_vm._v(_vm._s(this.agentContact))])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "deo-company-list-left"
  }, [_vm._v("其他说明")]), _vm._v(" "), _c('div', {
    staticClass: "deo-company-list-right"
  }, [_vm._v(_vm._s(this.remark))])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-from_main__bank"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticClass: "step-form_main__title"
  }, [_vm._v("银行账户信息")]), _vm._v(" "), _c('div', {
    class: this.$route.query.yanse == 1 ? 'deo-company-main-body2' : 'deo-company-main-body'
  }, _vm._l((_vm.bankAccounts), function(item) {
    return _c('ul', {
      staticClass: "deo-company-list-box"
    }, [_c('li', [_c('div', {
      staticClass: "deo-company-list-left"
    }, [_vm._v("银行名称")]), _vm._v(" "), _c('div', {
      staticClass: "deo-company-list-right"
    }, [_vm._v(_vm._s(item.bankName))])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "deo-company-list-left"
    }, [_vm._v("账户类型")]), _vm._v(" "), _c('div', {
      staticClass: "deo-company-list-right"
    }, [_vm._v(_vm._s(_vm._f("formatBankUseType")(item.bankUseType)))])]), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "deo-company-list-left"
    }, [_vm._v("银行卡号")]), _vm._v(" "), _c('div', {
      staticClass: "deo-company-list-right"
    }, [_vm._v(_vm._s(_vm._f("replaceBankcardNumWithStar")(item.bankAccountName)))])])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-from_main__enclosure"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    staticClass: "step-form_main__title"
  }, [_vm._v("资料附件")]), _vm._v(" "), _vm._l((_vm.fileTypeLists), function(item, index) {
    return (item.idsarr.length != 0) ? _c('div', {
      key: index,
      staticClass: "step-form_main__picture file-list__item-content"
    }, [_c('h5', {
      class: this.yanse == 1 ? 'smalltitle2' : 'smalltitle'
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', {
      staticClass: "file-list__item-list"
    }, [_vm._l((item.idsarr), function(file) {
      return [(/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)) ? _c('li', {
        class: ['file-list__item-preview', ("file-list__" + (file.fileName.substr(file.fileName.lastIndexOf('.')+1)) + "-preview")],
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showPreviewImage(file.fileId, false)
          }
        }
      }, [_c('div', {
        staticClass: "file-list__file-name"
      }, [_vm._v(_vm._s(file.fileName))])]) : _c('li', {
        staticClass: "file-list__item-preview"
      }, [_c('img', {
        attrs: {
          "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + (_vm.userInfo.token))
        },
        on: {
          "click": function($event) {
            return _vm.showPreviewImage(file.fileId, true)
          }
        }
      })])]
    })], 2)]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [(this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-prev2",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-next2",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 1) ? _c('button', {
    staticClass: "step-form__btn-next2",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.seeFinancing()
      }
    }
  }, [_vm._v("费用预估")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (this.$route.query.yanse == 2) ? _c('button', {
    staticClass: "step-form__btn-next",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.seeFinancing()
      }
    }
  }, [_vm._v("费用预估")]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "repaymentFrom"
  }, [_c('el-dialog', {
    attrs: {
      "title": "费用预估",
      "append-to-body": true,
      "modal": false,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "close": function($event) {
        return _vm.closeFrom()
      },
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "repaymentFrom_label"
  }, [_c('div', {
    staticClass: "flex_label"
  }, [_c('div', [_vm._v("融资申请金额(元)：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "disabled": true,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.step5Form.applyAmount),
      callback: function($$v) {
        _vm.$set(_vm.step5Form, "applyAmount", $$v)
      },
      expression: "step5Form.applyAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex_label flex_label_02"
  }, [_c('div', [_vm._v("融资期限：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "disabled": true,
      "placeholder": "请输入内容",
      "value": "今日"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    ref: "accountsReceivableEndTime",
    attrs: {
      "type": "date",
      "disabled": true,
      "placeholder": "融资到期时间",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": function($event) {
        return _vm.setFactime($event, 'accountsReceivableEndTime')
      }
    },
    model: {
      value: (_vm.financData.time),
      callback: function($$v) {
        _vm.$set(_vm.financData, "time", $$v)
      },
      expression: "financData.time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "repaymentFrom_label"
  }, [_c('div', {
    staticClass: "flex_label"
  }, [_c('div', [_vm._v("保理年化费率(%)：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "Number",
      "autosize": "",
      "maxlength": 3,
      "placeholder": "请输入保理费率"
    },
    on: {
      "change": function($event) {
        return _vm.feelvChange()
      }
    },
    model: {
      value: (_vm.financData.feelv),
      callback: function($$v) {
        _vm.$set(_vm.financData, "feelv", $$v)
      },
      expression: "financData.feelv"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex_label"
  }, [_c('div', [_vm._v("还款方式：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "disabled": true,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.financData.type),
      callback: function($$v) {
        _vm.$set(_vm.financData, "type", $$v)
      },
      expression: "financData.type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "repaymentFrom_label"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.testFlse()
      }
    }
  }, [_vm._v("预览还款计划")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.testShow),
      expression: "testShow"
    }],
    staticClass: "repaymentFrom_ul"
  }, [_c('div', {
    staticClass: "repaymentFrom_li"
  }, [_c('div', {
    staticClass: "repay-width repay-center repaymentFrom_num"
  }, [_vm._v("期数")]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repay-center repaymentFrom_principal"
  }, [_vm._v("本金")]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repay-center repaymentFrom_fee"
  }, [_vm._v("保理费")]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repay-center repaymentFrom_day"
  }, [_vm._v("计划还款日")]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repay-center repaymentFrom_amount"
  }, [_vm._v("计划还款金额")])]), _vm._v(" "), _c('div', {
    staticClass: "repaymentFrom_li"
  }, [_c('div', {
    staticClass: "repay-width repaymentFrom_num"
  }, [_vm._v(_vm._s(_vm.financData.nper))]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repaymentFrom_principal"
  }, [_vm._v(_vm._s(Number(_vm.step5Form.applyAmount).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repaymentFrom_fee"
  }, [_vm._v(_vm._s((Number(_vm.step5Form.applyAmount) * (_vm.financData.days - 1) * _vm.financData.feelv / 36000).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repaymentFrom_day"
  }, [_vm._v(_vm._s(_vm.step5Form.accountsReceivableEndTime))]), _vm._v(" "), _c('div', {
    staticClass: "repay-width repaymentFrom_amount"
  }, [_vm._v(_vm._s((Number(_vm.step5Form.applyAmount) + (Number(_vm.step5Form.applyAmount) * (_vm.financData.days - 1) * _vm.financData.feelv / 36000)).toFixed(2)))])])])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogTicketInfo,
      "show-close": true,
      "top": "70px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTicketInfo = $event
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contractText)
    }
  })]), _vm._v(" "), (_vm.dialogFormVisible) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae53d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step5.vue
// module id = 1102
// module chunks = 1